import { FC, ReactNode } from 'react';
import { Link as ReactLink, LinkProps } from 'react-router-dom';
import { As, Circle, Icon, Link, Text, VStack } from '@chakra-ui/react';
import { getDataTracking } from '../../utils';

export interface IconLinkProps {
  children: ReactNode;
  icon: As;
  iconColor?: string;
  iconSize?: string;
  isFilled?: boolean;
  onClick?: LinkProps['onClick'];
  textColor?: string;
  to: LinkProps['to'];
}

export const IconLink: FC<IconLinkProps> = ({
  children,
  icon,
  iconColor = 'black',
  iconSize = '24px',
  isFilled = false,
  onClick,
  textColor = 'black',
  to,
}) => (
  <Link
    as={ReactLink}
    textDecoration="none"
    to={to}
    _visited={{ color: textColor }}
    _hover={{
      boxShadow: '0px 0px 6px var(--chakra-colors-brand-primary-lightGrey)',
      borderRadius: '4px',
      color: textColor,
    }}
    onClick={onClick}
    {...getDataTracking(`${to}QuickLink`)}
  >
    <VStack w="90px" h="103px" p={2}>
      {isFilled ? (
        <Circle bg={iconColor} color="white" size="3rem">
          <Icon as={icon} color={iconColor} boxSize={iconSize} />
        </Circle>
      ) : (
        <Circle
          borderWidth="1px"
          borderStyle="solid"
          borderColor={iconColor}
          color={iconColor}
          size="3rem"
        >
          <Icon as={icon} color={iconColor} boxSize={iconSize} />
        </Circle>
      )}
      <Text color={textColor} fontSize={12} align="center">
        {children}
      </Text>
    </VStack>
  </Link>
);
